import Vue from 'vue'
import VueRouter from 'vue-router'
import Reports from '@/views/Reports'
import Login from '@/views/Login'
import Forgot from '@/views/Login/Forgot'
import Verify from '@/views/Login/Verify'

import { App, base, loggedOut } from '@/layouts'

import { logout, logoutFirst } from '@/lib/auth'
import BillingRoutes from './billing'
import NoNavRoutes from './no-nav'
import WizardRoutes from './wizard'
import YouRoutes from './you'


Vue.use(VueRouter)

const routes = [
  {
    path: '/claim/user/:claim_token',
    component: loggedOut,
    beforeEnter: logoutFirst,
    children: [
      {
        name: 'claim/verify',
        path: 'verify',
        props: true,
        component: () => import('@/views/Claim/Verify'),
      },
      {
        name: 'claim/user',
        path: '',
        props: true,
        component: () => import('@/views/Claim/User'),
      },
    ]
  },
  {
    path: '/login',
    component: loggedOut,
    children: [
      {
        name: 'login',
        path: '',
        component: Login,
      },
      {
        name: 'forgot',
        path: 'forgot',
        component: Forgot,
      },
      {
        name: 'verify',
        path: 'verify',
        component: Verify,
      },
      {
        name: 'login/privacy',
        path: 'privacy',
        component: () => import('@/views/PrivacyPolicy'),
      },
      {
        name: 'login/tos',
        path: 'eula',
        component: () => import('@/views/TOS'),
      },
    ],
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: logout,
  },
  {
    path: '/new/:pro_token',
    component: loggedOut,
    beforeEnter: logoutFirst,
    children: [
      {
        name: 'new/pro/create',
        path: 'create',
        props: true,
        component: () => import('@/views/New/Create')
      },
      {
        name: 'new/pro',
        path: '',
        props: true,
        component: () => import('@/views/New'),
      },
    ]
  },
  ...NoNavRoutes,
  ...WizardRoutes,
  {
    path: '',
    component: App,
    children: [
      ...BillingRoutes,
      ...YouRoutes,
      {
        name: 'home',
        path: 'home',
        component: () => import('@/views/Leads/List'),
      },
      {
        path: 'leads',
        component: base,
        children: [
          {
            name: 'leads',
            path: ':lead_id',
            props: true,
            component: () => import('@/views/Leads/Show'), 
          },
        ],
      },
      {
        name: 'reports',
        path: 'reports',
        component: Reports,
      },
      {
        name: 'default',
        path: '*',
        redirect: { name: 'home' },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// redirect to the new domain name
router.beforeEach((to, _from, next) => {
  const hostname = window.location.hostname
  const host = hostname.split('.').slice(0,-2).join('.')
  const tld = hostname.split('.').slice(-2).join('.')

  if (tld === 'partnerlists.com') {
    // Redirect to admin dashboard if on admin subdomain but not already there
    let url = window.location.protocol + '//' + host + '.referra.pro' + to.path
    window.location.replace(url)
  } else if (tld === 'partnerlistz.com') {
    let url = window.location.protocol + '//' + host + '.referraz.pro'
    url += window.location.port ? (':' + window.location.port + to.path) : to.path 
    window.location.replace(url)
  } else {
    next(); // Proceed with navigation
  }
})

export default router
